module.exports = "/assets/099f54882cef5c15040655fa50f09392.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/J1.png
// module id = 2618
// module chunks = 0